export const navigations = [
  { id: 'home', type: 'item', icon: 'map-marked-alt', title: 'Bản đồ giá', routeName: 'home', exact: true },
  // {id: 'map', type: 'item', icon: 'fa-map-marked-alt', title: 'Bản đồ', routeName: 'map.index'},
  { id: 'warehouse', type: 'item', icon: 'book-open', title: 'Kho giá', routeName: 'warehouse.index' },
  // { id: 'logAll', type: 'item', icon: 'history', title: 'Lịch sử ước tính', routeName: 'logAll.index' },
  { id: 'price_estimate', type: 'item', icon: 'money-bill-alt', title: 'Ước tính giá', routeName: 'price_estimate.index' },
  { id: 'log', type: 'item', icon: 'history', title: 'Lịch sử ước tính', routeName: 'log.index' },
  { id: 'certificate', type: 'item', icon: 'certificate', title: 'Tài sản thẩm định', routeName: 'certificate.index' },
  { id: 'certification_asset', type: 'item', icon: 'certificate', title: 'Tài sản thẩm định Ver.2', routeName: 'certification_asset.index' },
  { id: 'appraisal', type: 'item', icon: 'file-signature', title: 'Hồ sơ thẩm định', routeName: 'appraisal.index' },
  {
    id: 'appraise',
    type: 'item',
    icon: 'list-alt',
    title: 'Dữ liệu thẩm định',
    dropdown: [
      { id: 'appraise-law', title: 'Văn bản pháp luật', routeName: 'appraise-law.index', exact: true },
      { id: 'appraise-other', title: 'Cơ sở thẩm định', routeName: 'appraise-other.index', exact: true },
      { id: 'appraisal-construction', title: 'Đơn vị xây dựng', routeName: 'appraisal-construction.index', exact: true },
      { id: 'building', title: 'Quản lý loại công trình', routeName: 'building.index', exact: true },
      { id: 'element', title: 'Yếu tố so sánh', routeName: 'element.index', exact: true }
    ]
  },
  {
    id: 'category',
    type: 'item',
    icon: 'list-ul',
    title: 'Danh mục hành chính',
    dropdown: [
      { id: 'province', title: 'Quản lý Tỉnh/Thành', routeName: 'province.index', exact: true },
      { id: 'district', title: 'Quản lý Quận/Huyện', routeName: 'district.index', exact: true },
      { id: 'ward', title: 'Quản lý Phường/Xã', routeName: 'ward.index', exact: true },
      { id: 'street', title: 'Quản lý Đường phố', routeName: 'street.index', exact: true },
      { id: 'apartment', title: 'Quản lý Chung cư', routeName: 'apartment.index', exact: true },
      { id: 'unit', title: 'Quản lý đơn giá UBND', routeName: 'unit_price.index', exact: true },
      { id: 'dictionary', title: 'Quản lý Chung', routeName: 'dictionary.index', exact: true }

    ]
  },
  {
    id: 'manage',
    type: 'item',
    icon: 'users-cog',
    title: 'HRM',
    dropdown: [
      { id: 'role', type: 'item', title: 'Phân quyền', routeName: 'role.index', exact: true },
      { id: 'appraiser-company', title: 'Thông tin công ty', routeName: 'appraiser-company.index', exact: true },
      { id: 'branch', title: 'Quản lý Chi nhánh', routeName: 'branch.index', exact: true },
      { id: 'staff', type: 'item', title: 'Quản lý Nhân viên', routeName: 'staff.index', exact: true },
      { id: 'appraiser', title: 'Danh sách TDV', routeName: 'appraiser.index', exact: true }
    ],
    exact: true
  },

  { id: 'customer', type: 'item', icon: 'users', title: 'Quản lý đối tác', routeName: 'customer.index' },
  { id: 'import', type: 'item', icon: 'road', title: 'Thêm dữ liệu', routeName: 'import.index' },
  { id: 'configuration', type: 'item', icon: 'cogs', title: 'Cấu hình', routeName: 'configuration.index' },
  { id: 'workflow', type: 'item', icon: 'cogs', title: 'WorkFlow', routeName: 'workflow.index' }
]



// WEBPACK FOOTER //
// ./src/config/navigations.js